import styled from "styled-components";
import { Button, MediaQueries } from "ratel-ui";

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 45px 97px 80px;
  background: #f7f7f9;

  ${MediaQueries.mobileTablet`
    padding: 32px 32px 64px;
  `}

  ${MediaQueries.mobile`
    padding: 20px 12px 40px;
  `}
`;

export const Card = styled.div`
  width: 100%;
  max-width: 1172px;
  background: #ffffff;
  border: 1px solid rgba(10, 10, 10, 0.08);
  border-radius: 24px;
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.1);
  padding: 48px 56px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  ${MediaQueries.mobileTablet`
    padding: 40px 32px 32px;
  `}

  ${MediaQueries.mobile`
    padding: 28px 20px 24px;
    gap: 16px;
    border-radius: 20px;
  `}
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  background: #0e8a3e;
  border-radius: 999px;
  white-space: nowrap;

  ${MediaQueries.mobile`
    white-space: normal;
    text-align: center;
    padding: 10px 16px;
  `}
`;

export const BadgeDot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: #f7d518;
  flex-shrink: 0;
`;

export const BadgeText = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 14px;
  letter-spacing: 1.2px;
  color: #ffffff;

  ${MediaQueries.mobile`
    font-size: 12px;
    letter-spacing: 1px;
  `}
`;

export const Title = styled.h1`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 46px;
  line-height: 1.08;
  color: #0a0a0a;
  text-align: center;

  ${MediaQueries.mobileTablet`
    font-size: 36px;
  `}

  ${MediaQueries.mobile`
    font-size: 26px;
  `}
`;

export const Subtitle = styled.p`
  margin: 0;
  max-width: 618px;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 17px;
  line-height: 1.45;
  color: rgba(10, 10, 10, 0.7);
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 14.5px;
  `}
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  padding-top: 8px;

  ${MediaQueries.mobile`
    gap: 12px;
  `}
`;

export const StatCard = styled.div`
  flex: 1 0 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 20px 12px;
  background: #f5f5f6;
  border-radius: 16px;
`;

export const StatValue = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 40px;
  line-height: 1;
  color: #0e8a3e;

  ${MediaQueries.mobile`
    font-size: 32px;
  `}
`;

export const StatLabel = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  letter-spacing: 1.2px;
  color: rgba(10, 10, 10, 0.6);
  text-transform: uppercase;
`;

export const RulesBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 24px 28px;
  background: #f5f5f6;
  border-radius: 16px;

  ${MediaQueries.mobile`
    padding: 20px 18px;
  `}
`;

export const RulesTitle = styled.p`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 1.6px;
  color: #0e8a3e;
  text-transform: uppercase;
`;

export const RuleItem = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
`;

export const RuleNumber = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #0e8a3e;
  border-radius: 999px;
  color: #ffffff;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 11px;
  line-height: 1;
`;

export const RuleText = styled.p`
  margin: 0;
  flex: 1 0 0;
  min-width: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 400;
  font-size: 14.5px;
  line-height: 1.3;
  color: rgba(10, 10, 10, 0.8);

  strong {
    font-weight: 900;
    color: #0a0a0a;
  }
`;

export const StartButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px 48px;
  background: #0e8a3e;
  border: none;
  border-radius: 999px;
  color: #ffffff;
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  font-size: 18px;
  letter-spacing: 1px;
  white-space: nowrap;
  box-shadow: 0px 6px 16px rgba(14, 138, 62, 0.35);
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  width: auto;
  height: auto;
  margin-top: 8px;

  &:hover {
    background: #0c7434;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${MediaQueries.mobile`
    width: 100%;
    padding: 16px 24px;
    font-size: 15px;
  `}
`;

export const StartArrow = styled.span`
  font-family: "Nunito", sans-serif;
  font-weight: 900;
  line-height: 1;
`;

export const FooterNote = styled.p`
  margin: 0;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  font-size: 13px;
  color: rgba(10, 10, 10, 0.5);
  text-align: center;

  ${MediaQueries.mobile`
    font-size: 12px;
  `}
`;
